import React, { useState, useEffect, useRef } from 'react'
import './section2.css'

function Section2() {
  const [isHovered, setIsHovered] = useState(false);
  const [counter1, setCounter1] = useState(0);
  const [counter2, setCounter2] = useState(0);
  const [counter3, setCounter3] = useState(0);
  const animationStarted = useRef(false);

  useEffect(() => {
    if (isHovered && !animationStarted.current) {
      animationStarted.current = true;


      const duration1 = 1900;
      const increment1 = 95 / (duration1 / 30);
      let current1 = 0;

      const timer1 = setInterval(() => {
        current1 += increment1;
        if (current1 >= 95) {
          setCounter1(95);
          clearInterval(timer1);
          const duration2 = 1500;
          const increment2 = 90 / (duration2 / 30);
          let current2 = 0;

          const timer2 = setInterval(() => {
            current2 += increment2;
            if (current2 >= 90) {
              setCounter2(90);
              clearInterval(timer2);
              const duration3 = 1500;
              const increment3 = 99 / (duration3 / 30);
              let current3 = 0;

              const timer3 = setInterval(() => {
                current3 += increment3;
                if (current3 >= 99) {
                  setCounter3(99);
                  clearInterval(timer3);
                } else {
                  setCounter3(Math.floor(current3));
                }
              }, 30);
            } else {
              setCounter2(Math.floor(current2));
            }
          }, 30);
        } else {
          setCounter1(Math.floor(current1));
        }
      }, 30);

      return () => {
        clearInterval(timer1);
      };
    }
  }, [isHovered]);

  const handleMouseLeave = () => {
    setIsHovered(true);
    animationStarted.current = false;
  };

  return (
    <div className='section2MainContainer'>
      <div
        className='serviceDescContainer'
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={handleMouseLeave}
      >
        <div className='serviceDescHeading'>
          <p className='serviceDescHeading1'>Partner in Operational Excellence for <span style={{ fontStyle: 'italic', fontWeight: '700' }}>Growth</span></p>
          <p className='serviceDescHeading2'>With over a decade of operational expertise, we empower businesses to scale through structured backend solutions, from customer support to remote administration. All executed with precision, reliability, and brand alignment.</p>
        </div>
        <div className='serviceDescData'>
          <div className='serviceDescDataContent'>
            <p className='serviceDescDataContent1'>{counter1}%</p>
            <p className='serviceDescDataContent2'>Client Satisfaction</p>
          </div>
          <div className='serviceDescDataContent'>
            <p className='serviceDescDataContent1'>{counter2}%</p>
            <p className='serviceDescDataContent2'>Revenue Increased</p>
          </div>
          <div className='serviceDescDataContent'>
            <p className='serviceDescDataContent1'>{counter3 === 99 ? '99+' : counter3}</p>
            <p className='serviceDescDataContent2'>Happy Clients</p>
          </div>
        </div>
      </div>

      <div className='servicesContainer' id="services">
        <div className='servicesHeading'>
          <p>All Round <span style={ {fontWeight: '700' }}>Operations Solution</span></p>
        </div>
        <div className='servicesCardContainer'>
          <div style={{backgroundColor : '#E6E6F9'}} className='servicesCard'>
            <div className='serviceImg'>
              <img src='service1.png' alt=""></img>
            </div>
            <div className='serviceCardHeading'>
              <p>BPO</p>
            </div>
            <div className='serviceCardDesc'>
              <p>Comprehensive backend execution including customer service, admin tasks, and virtual team coordination for seamless operations.</p>
            </div>
          </div>

          <div className='servicesCard'>
            <div className='serviceImg'>
            <img src='service2.png' alt=""></img>
            </div>
            <div className='serviceCardHeading'>
              <p>Customer Support</p>
            </div>
            <div className='serviceCardDesc'>
              <p>Brand-aligned customer support solutions designed to enhance user satisfaction and scalability across channels.</p>
            </div>
          </div>

          <div style={{backgroundColor : '#E6E6F9'}} className='servicesCard'>
            <div className='serviceImg'>
            <img src='service3.png' alt=""></img>
            </div>
            <div className='serviceCardHeading'>
              <p>Salesforce Administration</p>
            </div>
            <div className='serviceCardDesc'>
              <p>Reliable CRM setup, streamlined workflow automation, and backend integrity to empower your sales operations.</p>
            </div>
          </div>

          <div className='servicesCard'>
            <div className='serviceImg'>
            <img src='service4.png' alt=""></img>
            </div>
            <div className='serviceCardHeading'>
              <p>Virtual Assistance</p>
            </div>
            <div className='serviceCardDesc'>
              <p>Flexible administrative support tailored for dynamic teams, global founders, and rapidly scaling operations.</p>
            </div>
          </div>

          <div style={{backgroundColor : '#E6E6F9'}} className='servicesCard'>
            <div className='serviceImg'>
            <img src='service5.png' alt=""></img>
            </div>
            <div className='serviceCardHeading'>
              <p>Remote Back Office</p>
            </div>
            <div className='serviceCardDesc'>
              <p>Efficient, behind-the-scenes operational support executed remotely to ensure day-to-day consistency.</p>
            </div>
          </div>

          <div className='servicesCard'>
            <div className='serviceImg'>
            <img src='service6.png' alt=""></img>
            </div>
            <div className='serviceCardHeading'>
              <p>Data Management</p>
            </div>
            <div className='serviceCardDesc'>
              <p>Accurate data entry, cleansing, and reporting to help maintain clean systems and enable informed decision-making.</p>
            </div>
          </div>

        </div>
        <div className='serviceButtonContainer'>
          <button>Explore All Solutions</button>
        </div>
      </div>

      <div className='growthContainer'>
        <div className='growthHeading'>
          <p>Together we fuel <span style={{ fontWeight : '700'}}>Your Growth</span></p>
        </div>
        <div className='growthContentContainer'>
          <div className='growthContent1'>
            <div className='growthContent1Desc'>
              <div>75% <span style={{color : '#993AFF', fontWeight : '300'}}>↑</span></div>
              <p>Average increase in sales for our clients</p>
            </div>
            <div className='growthContent1Desc'>
              <div>86% <span style={{color : '#993AFF', fontWeight : '300'}}>↑</span></div>
              <p>Average increase rantation rate for our client</p>
            </div>
            <div className='growthContent1Desc'>
              <div>93% <span style={{color : '#993AFF', fontWeight : '300'}}>↑</span></div>
              <p>Average increase in Traffic for our clients</p>
            </div>
          </div>
          
          <div className='growthContent2'>
            <img src='growthArrow.png' alt=""></img>
            <p className='growthContent2Heading'>540,000</p>
            <p className='growthContent2Desc'>Total Leads Harvested to This Point</p>
          </div>
        </div>
      </div>

      <div className='ourApproachContainer' id="approach">
        <div className='ourApproachHeadingContainer'>
          <p>Our Working <span style={{ fontWeight : '700'}}>Process</span></p>
        </div>
        <div className='processTimeline'>
          <div className='timelineTrack'>
            <div className='timelineLine'></div>
            <div className='timelineStep'>
              <div className='timelineCircle'></div>
              <div className='stepContentWrapper leftContent'>
                <div className='stepContent'>
                  <div className='stepNumber'>Step 1</div>
                  <h2 className='stepTitle'>Readiness</h2>
                  <p className='stepDescription'>
                  We do not wait for opportunity to knock — we build the door. By preparing in advance, we position ourselves ahead of the curve, ready to act when demand strikes. Our foresight is not luck — it is built into our rhythm.
                  </p>
                </div>
              </div>
              <div className='stepIconWrapper rightIcon'>
                <div className='stepIcon'>
                  <img src='step1.png' alt='Readiness icon' />
                </div>
              </div>
            </div>
            
           
            <div className='timelineStep'>
              <div className='timelineCircle'></div>
              <div className='stepIconWrapper leftIcon'>
                <div className='stepIcon'>
                  <img src='step2.png' alt='Clarity icon' />
                </div>
              </div>
              <div className='stepContentWrapper rightContent'>
                <div className='stepContent'>
                  <div className='stepNumber'>Step 2</div>
                  <h2 className='stepTitle'>Clarity</h2>
                  <p className='stepDescription'>
                  Complexity kills momentum. That is why we engineer systems that are intuitive, streamlined, and frictionless. When operations flow smoothly, focus shifts from fixing problems to seizing potential.
                  </p>
                </div>
              </div>
            </div>
            
            <div className='timelineStep'>
              <div className='timelineCircle'></div>
              <div className='stepContentWrapper leftContent'>
                <div className='stepContent'>
                  <div className='stepNumber'>Step 3</div>
                  <h2 className='stepTitle'>Discipline</h2>
                  <p className='stepDescription'>
                  We do not need spotlights to validate our work. Our excellence is silent, steady, and consistent — it shows up in the results. Execution isn't about noise; it's about precision and reliability.
                  </p>
                </div>
              </div>
              <div className='stepIconWrapper rightIcon'>
                <div className='stepIcon'>
                  <img src='step3.png' alt='Discipline icon' />
                </div>
              </div>
            </div>
            
            <div className='timelineStep'>
              <div className='timelineCircle'></div>
              <div className='stepIconWrapper leftIcon'>
                <div className='stepIcon'>
                  <img src='step4.png' alt='Craftsmanship icon' />
                </div>
              </div>
              <div className='stepContentWrapper rightContent'>
                <div className='stepContent'>
                  <div className='stepNumber'>Step 4</div>
                  <h2 className='stepTitle'>Craftsmanship</h2>
                  <p className='stepDescription'>
                  Automation is powerful, but it's the people behind it that make it meaningful. We empower skilled individuals who understand the tools, own the process, and deliver with intent. It's not just about speed — it's about mastery.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Section2